import React, { useRef, useState } from 'react';
import SubmissionConfirmation from '../submission_confirmation/SubmissionConfirmation';
import Form from '../form/Form';
import api from '../../api';

function AcceleratorApply() {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [loading, originalSetLoading] = useState(false);
  const loadingRef = useRef(loading);

  const setLoading = (value) => {
    loadingRef.current = value;
    originalSetLoading(value);
  };

  if (isSubmitted) {
    return <SubmissionConfirmation />;
  }

  const onSubmit = async (params) => {
    if (loadingRef.current) {
      return;
    }

    setLoading(true);

    const creatorBrandQuizParams = {
      email: params.email,
      name: params.name,
      phone: params.phone,
      social_media_handle: params.socialMediaHandle,
      largest_social_media_platform: params.largestSocialMediaPlatform,
      social_media_platform_size: params.socialMediaPlatformSize,
    };

    if (creatorBrandQuizParams.phone) {
      creatorBrandQuizParams.phone = params.phone.replace(/[^\d]/g, '');
    }

    try {
      await api.acceleratorApply({
        creator_brand_quiz: creatorBrandQuizParams,
      });

      setIsSubmitted(true);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  return <Form onSubmit={onSubmit} loading={loading} />;
}

export default AcceleratorApply;
